import { BENEFIT_ALLOCATION } from '../../api/endpoints';
import request from '../../api/request';
import {
  BenefitAllocationForm,
  BenefitAllocationHistoryItem,
  BenefitAllocationKind,
  UploadBenefitResult,
} from './types';

export function getBenefitAllocationForm() {
  return request<BenefitAllocationForm>(BENEFIT_ALLOCATION.FORM);
}

export function downloadTemplate(benefitTypeCode: BenefitAllocationKind) {
  return request<Blob>(BENEFIT_ALLOCATION.TEMPLATE(benefitTypeCode), {
    responseType: 'blob',
  });
}

export function uploadBenefitFile({
  code,
  academicYear,
  file,
}: {
  code: BenefitAllocationKind;
  academicYear: number;
  file: File;
}) {
  const data = new FormData();
  data.append('benefitTypeCode', code);
  data.append('academicYear', String(academicYear));
  data.append('file', file);
  return request<UploadBenefitResult>(BENEFIT_ALLOCATION.UPLOAD, {
    data,
    method: 'POST',
  });
}

export function getBenefitAllocationHistory(
  benefitTypeCode: BenefitAllocationKind,
) {
  return request<BenefitAllocationHistoryItem[]>(
    BENEFIT_ALLOCATION.HISTORY(benefitTypeCode),
  );
}

/**
 * Devuelve la URL firmada del archivo original de una carga. No trae el
 * binario: el blob se descarga después contra Azure, no contra la API.
 */
export function getHistoryFileUrl(batchId: number) {
  return request<{ url: string }>(BENEFIT_ALLOCATION.HISTORY_DOWNLOAD(batchId));
}

export function downloadFailureDetail(fileUploadFailureId: number | string) {
  return request<Blob>(
    BENEFIT_ALLOCATION.FILE_UPLOAD_FAILURE(fileUploadFailureId),
    { responseType: 'blob' },
  );
}
